export async function claimRewardAndStakeToTown(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { amount, delegatee, operatorAddress, beneficiary, signer } = fnArgs;
    if (!spaceDapp?.townsToken || !spaceDapp.config.addresses.utils.towns) {
        throw new Error('spaceDapp.townsToken is required for stakeToTowns operation.');
    }
    const townsAddress = spaceDapp.config.addresses.utils.towns;
    const rewardsAddress = spaceDapp.config.addresses.baseRegistry;
    if (!townsAddress || !rewardsAddress) {
        throw new Error('Towns and Rewards addresses are required for stakeToTowns operation.');
    }
    return smartAccount.sendUserOp({
        toAddress: [
            ...(operatorAddress ? [rewardsAddress] : []),
            rewardsAddress,
            townsAddress,
            rewardsAddress,
        ],
        callData: [
            ...(operatorAddress
                ? [
                    spaceDapp.baseRegistry.spaceDelegation.interface.encodeFunctionData('addSpaceDelegation', [delegatee, operatorAddress]),
                ]
                : []),
            spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('claimReward', [beneficiary, beneficiary]),
            spaceDapp.townsToken?.interface.encodeFunctionData('approve', [rewardsAddress, amount]),
            spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('stake', [
                amount,
                delegatee,
                beneficiary,
            ]),
        ],
        signer,
        spaceId: delegatee,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
